import React, { Fragment } from "react";
import { Box, Container, Grid, Typography } from "@material-ui/core";
import { formatLocaleDate } from "../utils/dateUtils";
import StaffRating from "./support/staff/StaffRating";
import { useSearchParams } from "react-router-dom";
import numberWithCommas from "../utils/commaFunc";
export default function BuyTicketWrapper({
  product,
  state,
  couponData,
  staffData,
  dateChangePage = false,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const reserveNowParam = searchParams.get("reserveNow")
    ? searchParams.get("reserveNow")
    : false;
  const reservationTimeParam = searchParams.get("reservationTime")
    ? searchParams.get("reservationTime")
    : false;
  const ticketNumber = state?.ticketNumber || product.ticketNumber;
  console.log(state);
  return (
    <Box className="card-wrapper buy-ticket">
      <Box className="mit-card">
        {!dateChangePage && (
          <Grid
            container
            alignItems="flex-end"
            spacing={2}
            style={{ marginBottom: "20px" }}
          >
            <Grid item md sm={12} xs={12}>
              <Box>
                <Grid
                  container
                  alignItems="center"
                  style={{ gap: "40px" }}
                  className="buy-ticket-title-wrapper"
                >
                  <Grid
                    item
                    md={"auto"}
                    className="ticket-image-wrapper"
                    sm={4}
                    xs={4}
                  >
                    {product.productType == "TIP" ? (
                      <img
                        src={`/images/tip-${
                          product.price || product.amount
                        }.png`}
                        className={"ticket-image " + product.productType}
                      />
                    ) : (
                      <Fragment>
                        {product.minutesToSupport ? (
                          <img
                            src={`/images/${product.minutesToSupport}-min-ticket.png`}
                            alt=""
                            className={"ticket-image " + product.productType}
                          />
                        ) : (
                          <img
                            src={
                              product.productType == "INTERVIEW"
                                ? "/images/interview-image.png"
                                : "/images/ticketpng.png"
                            }
                            alt=""
                            className={"ticket-image " + product.productType}
                          />
                        )}
                      </Fragment>
                    )}
                  </Grid>
                  <Grid item md sm xs>
                    <Typography
                      style={{
                        fontSize: "1.6rem",
                      }}
                      className="classification-heading"
                    >
                      {product.productName}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item md={5} sm={12} xs={12} style={{ textAlign: "right" }}>
              {couponData && couponData.data.couponAvailable ? (
                <Fragment>
                  <div className="price-strike price">
                    <span>{numberWithCommas(couponData.data.price)}</span>円
                    (税込)
                  </div>
                  <div className="new-price">
                    <div className="coup">クーポン適用</div>
                    <div className="price">
                      <em>合計 </em>
                      <span>
                        {numberWithCommas(couponData.data.couponPrice)}
                      </span>
                      円 (税込)
                    </div>
                  </div>
                </Fragment>
              ) : (
                <div className="price">
                  <em>合計 </em>
                  <span>
                    {numberWithCommas(product.price || product.amount)}
                  </span>
                  円 (税込)
                </div>
              )}
            </Grid>
          </Grid>
        )}

        {!["INTERVIEW", "TIP", "ADD"].includes(product.productType) && (
          <Grid container className="rating-table">
            {ticketNumber && (
              <Fragment>
                <Grid item md={3} sm={3} xs={3}>
                  <Typography variant={"h6"}>チケット番号</Typography>
                </Grid>
                <Grid item md={9} xs={9} sm={9}>
                  <Typography variant={"h6"}>{ticketNumber}</Typography>
                </Grid>
              </Fragment>
            )}
            {state?.ticket ? (
              <Fragment>
                <Grid item md={3} sm={3} xs={3}>
                  <Typography variant={"h6"}>チケット</Typography>
                </Grid>
                <Grid item md={9} sm={9} xs={9}>
                  <Typography variant={"h6"}>
                    {state.ticket.productName} (目安時間{" "}
                    {state.ticket.minutesToSupport}
                    分)
                  </Typography>
                </Grid>
              </Fragment>
            ) : (
              product.productName && (
                <Fragment>
                  <Grid item md={3} sm={3} xs={3}>
                    <Typography variant={"h6"}>チケット</Typography>
                  </Grid>
                  <Grid item md={9} sm={9} xs={9}>
                    <Typography variant={"h6"}>
                      {product.productName} (目安時間 {product.minutesToSupport}
                      分)
                    </Typography>
                  </Grid>
                </Fragment>
              )
            )}
            {!["INTERVIEW", "TIP", "ADD"].includes(product.productType) && (
              <Fragment>
                <Grid item md={3} sm={3} xs={3}>
                  <Typography variant={"h6"}>担当相談員</Typography>
                </Grid>
                <Grid item md={9} sm={9} xs={9}>
                  <Grid
                    className="agent-details"
                    container
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid container spacing={2} alignItems="flex-end" item md>
                      <Grid
                        item
                        md={6}
                        container
                        spacing={2}
                        alignItems="center"
                      >
                        <Grid item xs={"auto"}>
                          {state?.staffInfo?.staffNickname == "指名なし" ? (
                            <img
                              src={"/images/staff_free.png"}
                              style={{
                                width: "120px",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <img
                              src={
                                state?.staffInfo.staffImageUrl ||
                                product.staffImageUrl ||
                                staffData?.staffImageUrl ||
                                "/images/staff_noimage.png"
                              }
                              className="buy-ticket-img"
                            />
                          )}
                        </Grid>
                        <Grid item xs>
                          <Typography style={{ marginBottom: "0" }}>
                            {state?.staffInfo.staffNickname ||
                              product?.staffNickname ||
                              staffData?.staffNickname}
                          </Typography>
                          <Typography style={{ marginBottom: "0" }}>
                            {state?.staffInfo.staffAge &&
                              state.staffInfo.staffAge + ","}
                            {product?.staffAge && product.staffAge + ","}
                            {staffData?.staffAge && staffData.staffAge + ","}
                            {state?.staffInfo.staffGender ||
                              (product.staffGender && (
                                <Fragment>
                                  {state?.staffInfo.staffGender == "MALE" ||
                                  product.staffGender == "MALE"
                                    ? "男性"
                                    : "女性"}
                                </Fragment>
                              ))}
                            {staffData?.staffGender && (
                              <Fragment>
                                {staffData?.staffGender == "MALE"
                                  ? "男性"
                                  : "女性"}
                              </Fragment>
                            )}
                          </Typography>
                          {state?.staffInfo.averageScore && (
                            <StaffRating
                              rating={state?.staffInfo.averageScore}
                            />
                          )}
                          {staffData?.averageScore && (
                            <StaffRating rating={staffData?.averageScore} />
                          )}
                          {product?.averageScore && (
                            <StaffRating rating={product?.averageScore} />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    {state?.staffInfo.type == "noAssign" && (
                      <Grid item md={"auto"}>
                        <div className="ticket-bottom-text">
                          おすすめの相談員を
                          <br />
                          ご案内いたします！
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Fragment>
            )}
            {reservationTimeParam ? (
              <Fragment>
                <Grid item md={3} sm={3} xs={3}>
                  <Typography variant={"h6"}>日時</Typography>
                </Grid>
                <Grid item md={9} sm={9} xs={9}>
                  <Typography variant="h6">
                    {formatLocaleDate(reservationTimeParam.split("-")[1])}{" "}
                    {reservationTimeParam.split("-")[2]}:
                    {reservationTimeParam.split("-")[3]}
                  </Typography>
                </Grid>
              </Fragment>
            ) : (
              <Fragment>
                {state?.time ? (
                  <Fragment>
                    <Grid item md={3} sm={3} xs={3}>
                      <Typography variant={"h6"}>日時</Typography>
                    </Grid>
                    <Grid item md={9} sm={9} xs={9}>
                      <Typography variant="h6">
                        {formatLocaleDate(state.date)}{" "}
                        {state?.time.replace("-", ":")}
                      </Typography>
                    </Grid>
                  </Fragment>
                ) : (
                  product.reservationTime && (
                    <Fragment>
                      <Grid item md={3} sm={3} xs={3}>
                        <Typography variant={"h6"}>日時</Typography>
                      </Grid>
                      <Grid item md={9} sm={9} xs={9}>
                        <Typography variant="h6">
                          {formatLocaleDate(
                            product.reservationTime.split("-")[1]
                          )}{" "}
                          {product.reservationTime.split("-")[2]}:
                          {product.reservationTime.split("-")[3]}
                        </Typography>
                      </Grid>
                    </Fragment>
                  )
                )}
              </Fragment>
            )}
          </Grid>
        )}
      </Box>
    </Box>
  );
}
